// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-table .cell-wrapper.status .error {
  color: red;
}

.virtual-table .cell-wrapper.paused span,
.virtual-table .cell-wrapper.paused .label,
.virtual-table .cell-wrapper.paused a {
  color: gray !important;
}

.virtual-table .cell-wrapper.failed span,
.virtual-table .cell-wrapper.failed .label,
.virtual-table .cell-wrapper.failed a {
  color: red;
  font-weight: bold !important;
}

.virtual-table .cell-wrapper.downloaded span,
.virtual-table .cell-wrapper.downloaded .label,
.virtual-table .cell-wrapper.downloaded a {
  color: green !important;
}


@media only screen and (min-width: 767px) {
  .source.modal td {
    max-width: 250px;
  }

  /* Can't be applied to dropdown cells */
  .source.modal td:not(.user) {
    overflow-x: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Queue/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;;EAGE,uBAAuB;AACzB;;;AAGA;EACE;IACE,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".virtual-table .cell-wrapper.status .error {\r\n  color: red;\r\n}\r\n\r\n.virtual-table .cell-wrapper.paused span,\r\n.virtual-table .cell-wrapper.paused .label,\r\n.virtual-table .cell-wrapper.paused a {\r\n  color: gray !important;\r\n}\r\n\r\n.virtual-table .cell-wrapper.failed span,\r\n.virtual-table .cell-wrapper.failed .label,\r\n.virtual-table .cell-wrapper.failed a {\r\n  color: red;\r\n  font-weight: bold !important;\r\n}\r\n\r\n.virtual-table .cell-wrapper.downloaded span,\r\n.virtual-table .cell-wrapper.downloaded .label,\r\n.virtual-table .cell-wrapper.downloaded a {\r\n  color: green !important;\r\n}\r\n\r\n\r\n@media only screen and (min-width: 767px) {\r\n  .source.modal td {\r\n    max-width: 250px;\r\n  }\r\n\r\n  /* Can't be applied to dropdown cells */\r\n  .source.modal td:not(.user) {\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
